import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import Wrapper from '../elements/wrapper';

import { MegaMenuStyles } from './header-styles';
const MegaMenu = ({ primaryMMNav, subNavs, subNavActive, setSubNavActive }) => {
    function handleMouseOver(index) {
        setSubNavActive(index);
    }
    return (
        <MegaMenuStyles>
            <Wrapper className="mega-menu-outer-wrapper">
                <nav className="mm-nav-container">
                    <ul className="mm-nav">
                        {primaryMMNav &&
                            primaryMMNav.map((link, index) => {
                                return (
                                    <li key={index}>
                                        <a
                                            onMouseEnter={() =>
                                                handleMouseOver(index)
                                            }
                                            href="#"
                                            className={
                                                index === subNavActive
                                                    ? 'active'
                                                    : ''
                                            }
                                        >
                                            {link.title}
                                        </a>
                                    </li>
                                );
                            })}
                    </ul>
                </nav>
                <div className="sub-navs-outer-container">
                    {subNavs &&
                        subNavs.map((subNav, index) => {
                            const { feat_content } = subNav || {};
                            return (
                                <div
                                    className={
                                        index === subNavActive
                                            ? 'sub-nav-container active'
                                            : 'sub-nav-container'
                                    }
                                >
                                    <nav>
                                        <ul className="sub-nav first">
                                            {subNav.links &&
                                                subNav.links
                                                    .slice(0, 6)
                                                    .map((linkNode, index) => {
                                                        let link =
                                                            linkNode.link;
                                                        return (
                                                            <li key={index}>
                                                                <Link
                                                                    to={
                                                                        link.url
                                                                    }
                                                                >
                                                                    {link.title}
                                                                </Link>
                                                            </li>
                                                        );
                                                    })}
                                        </ul>
                                        <ul className="sub-nav">
                                            {subNav.links &&
                                                subNav.links
                                                    .slice(6, subNav.length)
                                                    .map((linkNode, index) => {
                                                        let link =
                                                            linkNode.link;
                                                        return (
                                                            <li key={index}>
                                                                <Link
                                                                    to={
                                                                        link.url
                                                                    }
                                                                >
                                                                    {link.title}
                                                                </Link>
                                                            </li>
                                                        );
                                                    })}
                                        </ul>
                                    </nav>

                                    {feat_content &&
                                        feat_content.image &&
                                        feat_content.link && (
                                            <div className="image-container">
                                                <Link
                                                    to={feat_content.link.url}
                                                >
                                                    <Img
                                                        fluid={
                                                            feat_content.image
                                                        }
                                                    />
                                                    <p>
                                                        {
                                                            feat_content.link
                                                                .title
                                                        }
                                                    </p>
                                                </Link>
                                            </div>
                                        )}
                                </div>
                            );
                        })}
                </div>
            </Wrapper>
        </MegaMenuStyles>
    );
};

export default MegaMenu;
